export default __webpack_public_path__ + "static/media/grid.eba9b7e6.svg";